import getiPhoneModel from './getIphoneModel'
import { slugify } from '../String'

const USER_AGENT = navigator.userAgent.toLowerCase()

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
export default class Support
{
    constructor()
    {
        this.touch = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)
        this.android = USER_AGENT.indexOf('android') > -1
        this.ios = /iPad|iPhone|iPod|ipad|iphone|ipod/.test(USER_AGENT) && !window.MSStream
        this.ie = document.documentMode || /Edge/.test(USER_AGENT)

        // Get the device
        this.mac = navigator.platform.indexOf('Mac') > -1
        this.windows = navigator.platform.indexOf('Win') > -1
        this.iphone = /iPhone|iphone/.test(USER_AGENT)
        this.ipad = /iPad|ipad/.test(USER_AGENT)
        this.ipod = /iPod|ipod/.test(USER_AGENT)

        // Get the navigator
        this.defaultNavigator = (USER_AGENT.indexOf('turbobrowser') > -1)
        this.opera = (USER_AGENT.indexOf('opr') > -1) && !this.defaultNavigator
        this.edge = (USER_AGENT.indexOf('edgios') > -1) || (USER_AGENT.indexOf('edge') > -1) && !this.defaultNavigator
        this.chrome = (USER_AGENT.indexOf('crios') > -1 || USER_AGENT.indexOf('chrome') > -1) && !this.defaultNavigator && !this.edge
        this.firefox = (USER_AGENT.indexOf('fxios') > -1 || USER_AGENT.indexOf('firefox') > -1) && !this.defaultNavigator
        this.ucbrowser = (USER_AGENT.indexOf('ucbrowser') > -1) && !this.defaultNavigator
        this.safari = (USER_AGENT.indexOf('safari') > -1) && !this.opera && !this.chrome && !this.firefox && !this.edge && !this.defaultNavigator && !this.ucbrowser

        if (this.iphone)
        {
            this[getiPhoneModel()] = true
        }

        this.class = this._getClass()

        this.hasWheelEvent = 'onwheel' in document
        this.hasMouseWheelEvent = 'onmousewheel' in document
        this.hasTouchWin = navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1
        this.hasPointer = !!window.navigator.msPointerEnabled
        this.hasKeyDown = 'onkeydown' in document
    }

    _getClass()
    {
        return Object.keys(this).map(key =>
        {
            if (key === 'ie'
                && this[key])
            {
                return `is-${key} is-${key}-${this[key]}`
            }
            else if (this[key]
                && key.length > 3
                && key.substr(0, 3) === 'has')
            {
                return slugify(key)
            }
            else if (this[key])
            {
                return `is-${slugify(key)}`
            }

            return false
        }).filter(c => c !== false).join(' ')
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/global/Support.js